import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-337680f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-employee-multiselect" }
const _hoisted_2 = {
  key: 0,
  class: "task-employee-multiselect__required-indicator"
}
const _hoisted_3 = { class: "task-employee-multiselect__content" }
const _hoisted_4 = { class: "task-employee-multiselect__popover-title" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "remove-task-modal__content" }
const _hoisted_7 = {
  key: 2,
  class: "task-employee-multiselect__button"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  style: {"font-weight":"500"}
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "task-employee-multiselect__selected-content" }

import { computed, nextTick, onMounted, PropType, ref, watch } from "vue";
import { UserModel } from "../../models";
import {
  TirPmMultiselect,
  TirPmSelectBadge,
  TirPmIconView,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmPopover,
  PopoverPositionEnum,
  PopoverColorEnum,
  TirPmModal,
  TirPmDropdown,
  TirPmTooltipElement,
} from "tir-components";
import { EmployeeMultiselectOptionModel } from "./models";
import { PlusIcon } from "tir-style-system/icons/outline";
import { CurrentUser } from "tir-pm-user-core";
import { useModal } from "tir-pm-toolkit";

const countVisibleOptions = 4;

export default /*#__PURE__*/_defineComponent({
  __name: 'task-employee-multiselect',
  props: {
  /**Выбранные сотрудники */
  modelValue: {
    type: Array as PropType<Array<number>>,
    default: [],
  },
  /**Возможность редактировать */
  editing: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
  /**Сотрудники для выбора */
  employees: {
    type: Array as PropType<Array<UserModel>>,
    requred: true,
  },
  /**Ширина */
  width: {
    type: String,
    default: "100%",
  },
  /**Лейбл */
  label: {
    type: String,
  },
  /**Ошибка */
  isError: {
    type: Boolean,
    default: false,
  },
  /**Обязательное поле */
  isRequired: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;





/**Ссылка на элемент подсказки */
const $tooltip = ref<InstanceType<typeof TirPmTooltipElement>>();
const isOpened = ref(false);

/**Опции Dropdown */
const optionsDropdown = [
  {
    text: "Открепить",
  },
];

/**Опции для мультиселекта */
const options = computed(() => {
  return props.employees.map((employee) => {
    return new EmployeeMultiselectOptionModel({
      Id: employee.Id,
      FirstName: employee.FirstName,
      LastName: employee.LastName,
      MiddleName: employee.MiddleName,
      ImageUrl: employee.ImageUrl,
      AvatarColor: employee.AvatarColor,
    });
  });
});

/**Выбранные опции */
const selectedOptions = computed(() =>
  options.value.filter((option) => props.modelValue.some((employeeId) => option.Id === employeeId)),
);

/**Кол-во видимых опций */
const isOpenMultiselect = ref();
/**Состояние открытой модели удаления сотрудника */
const removeModalState = ref();

const checkOpenMultiselect = () => {
  isOpenMultiselect.value = !isOpenMultiselect.value;

  // event.stopPropagation();//TODO непонял за чем  и так пашет
  document.addEventListener("click", () => {
    isOpenMultiselect.value = false;
  });
};
/**Видимые выбранные опции */
const visibleOptions = computed(() => selectedOptions.value.slice(0, countVisibleOptions));
/**Кол-во скрытых выбранных опций */
const countHiddenOptions = computed(
  () => selectedOptions.value.length - visibleOptions.value.length,
);

/**При открытии Dropdown */
const openDropdown = (idx) => {
  $tooltip.value[idx]?.close();
  setTimeout(() => {
    isOpened.value = true;
  }, 100);
};

/**При закрытии Dropdown */
const closeDropdown = () => {
  isOpened.value = false;
};

/**Данные сотрудника */
const dataEmployee = ref();

/**Открытие модалки для открепления сотрудника */
const openRemoveModal = (id: number, firstName: string, lastName: string) => {
  dataEmployee.value = {
    id: id,
    firstName: firstName,
    lastName: lastName,
  };
  removeModalState.value = true;
};

const closeModal = () => {
  removeModalState.value = false;
};
const selectEmployee = (employeeId: number) => {
  emit("update:modelValue", [...props.modelValue, employeeId]);
};

const unSelectEmployee = (employeeId: number) => {
  emit(
    "update:modelValue",
    props.modelValue.filter((_employeeId) => employeeId !== _employeeId),
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(['task-employee-multiselect__label', { 'is-error': __props.isError }])
        }, [
          _createTextVNode(_toDisplayString(__props.label), 1),
          (__props.isRequired)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (visibleOptions.value.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(visibleOptions.value, (elem, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "task-employee-multiselect__avatar-row",
              key: idx
            }, [
              _createVNode(_unref(TirPmDropdown), {
                class: "task-employee-multiselect__dropdown",
                options: optionsDropdown,
                popoverPosition: _unref(PopoverPositionEnum).Top,
                onOnOpen: ($event: any) => (openDropdown(idx)),
                onOnClose: closeDropdown
              }, {
                target: _withCtx(() => [
                  _createVNode(_unref(TirPmTooltipElement), {
                    ref_for: true,
                    ref_key: "$tooltip",
                    ref: $tooltip,
                    width: "max-content"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(elem.FirstName) + " " + _toDisplayString(elem.MiddleName) + " " + _toDisplayString(elem.LastName), 1)
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_unref(TirPmIconView), {
                        class: "task-employee-multiselect__avatar",
                        size: 24,
                        isRounded: "",
                        isBordered: false,
                        colorCode: elem.AvatarColor,
                        imageLoadUrl: elem.ImageUrl,
                        key: elem.Id
                      }, {
                        mainSlot: _withCtx(() => [
                          _createTextVNode(_toDisplayString(elem.FirstNameLetterAndFirstLastNameLetter), 1)
                        ]),
                        _: 2
                      }, 1032, ["colorCode", "imageLoadUrl"]))
                    ]),
                    _: 2
                  }, 1536)
                ]),
                optionList: _withCtx(({ option }) => [
                  _createElementVNode("div", {
                    class: "task-employee-multiselect__dropdown-title",
                    onClick: ($event: any) => (openRemoveModal(elem.Id, elem.FirstName, elem.LastName))
                  }, _toDisplayString(option.text) + " " + _toDisplayString(elem.FirstName) + " " + _toDisplayString(elem.LastName[0]) + ". ", 9, _hoisted_5)
                ]),
                _: 2
              }, 1032, ["popoverPosition", "onOnOpen"]),
              _createVNode(_unref(TirPmModal), {
                title: "Открепить сотрудника",
                "is-visible": removeModalState.value,
                isWithBack: false,
                isCloseOverlay: true,
                onClose: closeModal
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(dataEmployee.value.firstName) + " " + _toDisplayString(dataEmployee.value.lastName[0]) + ". больше не сможет взаимодействовать с тикетом и получать уведомления об изменениях ", 1)
                ]),
                footer: _withCtx(() => [
                  _createVNode(_unref(TirPmButton), {
                    variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (unSelectEmployee(dataEmployee.value.id)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Открепить ")
                    ]),
                    _: 1
                  }, 8, ["variant"]),
                  _createVNode(_unref(TirPmButton), {
                    variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                    onClick: closeModal
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Отмена ")
                    ]),
                    _: 1
                  }, 8, ["variant"])
                ]),
                _: 1
              }, 8, ["is-visible"])
            ]))
          }), 128))
        : _createCommentVNode("", true),
      (countHiddenOptions.value)
        ? (_openBlock(), _createBlock(_unref(TirPmIconView), {
            key: 1,
            class: "task-employee-multiselect__avatar",
            size: 24,
            isRounded: "",
            isBordered: false
          }, {
            mainSlot: _withCtx(() => [
              _createTextVNode(" +" + _toDisplayString(countHiddenOptions.value), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (__props.editing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_unref(TirPmMultiselect), {
              options: options.value,
              "selected-options": selectedOptions.value,
              style: _normalizeStyle({ width: __props.width }),
              "popover-position": _unref(PopoverPositionEnum).Right,
              width: "100%",
              onOnOpen: checkOpenMultiselect
            }, {
              target: _withCtx(() => [
                (!__props.modelValue.length)
                  ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                      key: 0,
                      size: _unref(TirPmButtonSizeEnum).Small,
                      isPressed: isOpenMultiselect.value,
                      variant: _unref(TirPmButtonVariantEnum).SecondaryState
                    }, {
                      leftSlot: _withCtx(() => [
                        _createVNode(_unref(PlusIcon))
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" Добавить ")
                      ]),
                      _: 1
                    }, 8, ["size", "isPressed", "variant"]))
                  : (_openBlock(), _createBlock(_unref(TirPmButton), {
                      key: 1,
                      size: _unref(TirPmButtonSizeEnum).Small,
                      variant: _unref(TirPmButtonVariantEnum).LinkState,
                      isPressed: isOpenMultiselect.value
                    }, {
                      leftSlot: _withCtx(() => [
                        _createVNode(_unref(PlusIcon), { style: {"color":"var(--text-primary, #272d37)"} })
                      ]),
                      _: 1
                    }, 8, ["size", "variant", "isPressed"]))
              ]),
              optionList: _withCtx(({ option }) => [
                _createElementVNode("div", {
                  class: "task-employee-multiselect__options-list",
                  onClick: ($event: any) => (selectEmployee(option.Id))
                }, [
                  _createVNode(_unref(TirPmIconView), {
                    class: "task-employee-multiselect__avatar",
                    size: 24,
                    isRounded: "",
                    isBordered: false,
                    colorCode: option.AvatarColor,
                    imageLoadUrl: option.ImageUrl
                  }, {
                    mainSlot: _withCtx(() => [
                      _createTextVNode(_toDisplayString(option.FirstNameLetterAndFirstLastNameLetter), 1)
                    ]),
                    _: 2
                  }, 1032, ["colorCode", "imageLoadUrl"]),
                  (option.Id === _unref(CurrentUser).Id)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Назначить себя"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(option.FirstAndLastName), 1))
                ], 8, _hoisted_8)
              ]),
              left: _withCtx(() => [
                _renderSlot(_ctx.$slots, "left")
              ]),
              selectedContent: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedOptions.value, (option) => {
                    return (_openBlock(), _createBlock(_unref(TirPmSelectBadge), {
                      "is-closable": "",
                      onClose: ($event: any) => (unSelectEmployee(option.Id))
                    }, {
                      sign: _withCtx(() => [
                        _createTextVNode(_toDisplayString(option.FirstNameLetterAndFirstLastNameLetter), 1)
                      ]),
                      iconViewAddon: _withCtx(() => [
                        _createVNode(_unref(TirPmIconView), {
                          class: "task-employee-multiselect__avatar",
                          size: 24,
                          isRounded: "",
                          isBordered: false,
                          colorCode: option.AvatarColor,
                          imageLoadUrl: option.ImageUrl
                        }, {
                          mainSlot: _withCtx(() => [
                            _createTextVNode(_toDisplayString(option.FirstNameLetterAndFirstLastNameLetter), 1)
                          ]),
                          _: 2
                        }, 1032, ["colorCode", "imageLoadUrl"])
                      ]),
                      _: 2
                    }, 1032, ["onClose"]))
                  }), 256))
                ])
              ]),
              _: 3
            }, 8, ["options", "selected-options", "style", "popover-position"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})